<template lang="jade">
  .container-fluid
    .row
        .status_main.col-md-12
          header.status_title_bar.main_title_bar.clearfix
            h1.title.col-md-10.col-sm-10.col-xs-12
              | Analysis
              //- span {{powerSeries | json}}
              //- span {{currenSeries | json}}
              //- span filter {{filter | json}}
              span.deviceTime.col-md-3.pull-right.no_pad
                |{{deviceTime}}
          section.analysis_content
            section.input_voltage.clearfix.row_space--xxs
              .col-lg-6.col-md-6.col-xs-12.clear-left.clearfix.no_pad-xs
                #inputVoltage.char
            section.banks.clearfix.row_space--xxs
              //- span {{testData.input | json}}
              .reminding.col-sm-12.no_pad-xs
                span You can select 3 outlets at most
              .col-xs-12.col-sm-12.col-lg-12.filter_group.no_pad-xs
                .filter__single.fa_checkbox.clearfix(v-for='(key,bank) in testData.banks' v-bind:class="{'blue': filter.indexOf(key) === 0, 'orange':filter.indexOf(key) === 1, 'green': filter.indexOf(key) === 2}")
                  input(type='checkbox' name='filter' v-bind:value='key' v-model='filter' v-bind:id="'bank'+key+'_filter'")
                  label(v-bind:for="'bank'+key+'_filter'" v-on:click='chkAmount()')
                    span Outlet{{key}}
                    //- span {{filter.indexOf(key)}}
              .row
                .bank__single.col-lg-6.col-md-6.col-xs-12.row_space--xxs
                  #bankCurrent.char
              .row
                .bank__single.col-lg-6.col-md-6.col-xs-12.row_space--xxs
                  #bankPower.char
</template>

<script>
import { render as renderChart, exec } from 'zingchart'
import _ from 'lodash'
import { call } from 'src/Service.js'
import MobileDetect from 'mobile-detect'
import moment from 'moment'
const DEVICE_TIME_FORMAT = 'DD-MM-YYYY HH:mm:ss'

let BEHAVIOR_CONFIG = [
  { id: 'About', enabled: 'none' },
  { id: 'ViewSource', enabled: 'none' },
  { id: 'Reload', enabled: 'none' }
]
let MOBILE_BEHAVIOR_CONFIG = [
  { id: 'About', enabled: 'none' },
  { id: 'ViewSource', enabled: 'none' },
  { id: 'Print', enabled: 'none' },
  { id: 'DownloadPDF', enabled: 'none' },
  { id: 'DownloadSVG', enabled: 'none' },
  { id: 'SaveAsImage', enabled: 'none' },
  { id: 'Reload', enabled: 'none' }
]

export default {
  components: {
  },
  asyncData () {
    let md = new MobileDetect(window.navigator.userAgent)
    call(this.$route.params.mac, 'dxGetTimeZone').then(({timezone}) => {
      this.timezone = timezone
      return call(this.$route.params.mac, 'dxGetPowerStatus')
    })
    .then(data => {
      console.log('async')
      this.input = _.cloneDeep(data.input)
      this.banks = _.cloneDeep(data.banks)
      // There is no input color in colors
      let colors = [
        '#1f77b4',
        '#ff7f0e',
        '#357935'
      ]
      this.curSeries = []
      this.powerSeries = []
      for (let [idx, key] of this.filter.entries()) {
        let obj = {
          text: `Bank${key}`,
          values: [],
          marker: {
            visible: false
          },
          scales: 'scale-x,scale-y',
          'line-color': colors[idx]
        }
        this.curSeries.push(obj)
        this.powerSeries.push(obj)
      }
      let vue = this
      // render the chart
      console.log('render chart')
      renderChart({
        // if you want to change this id , remember to change the selector name in <style> of App.vue
        // there is an !important style to hide the About Zingchart option in App.vue
        id: 'inputVoltage',
        data: {
          gui: {
            contextMenu: {
              button: {
                visible: true
              },
              'custom-items': [
                {
                  id: 'reloadInput',
                  function: 'reloadInput()',
                  text: 'Reload'
                }
              ],
              position: 'right'
            },
            behaviors: md.mobile() !== null ? MOBILE_BEHAVIOR_CONFIG : BEHAVIOR_CONFIG
          },
          graphset: [
            {
              title: {
                text: 'Voltage (Input/Outputs)',
                bold: false,
                fontSize: md.mobile() !== null ? '14px' : '18px'
              },
              type: 'line',
              x: 0,
              y: 0,
              height: 250,
              width: '100%',
              plotarea: {
                margin: '50 25 20 50'
              },
              'scale-y': {
                values: this.isEurope ? '260:200:10' : '135:85:10',
                format: '%v V'
              },
              'scale-x': {
                step: 1000,
                transform: {
                  type: 'date',
                  text: '%H:%i:%s',
                  item: {
                    visible: false
                  }
                }
              },
              refresh: {
                type: 'feed',
                resetTimeout: 1000,
                transport: 'js',
                url: 'inputVoltageCallback()',
                maxTicks: 30,
                interval: 1000
              },
              series: [
                {
                  values: [],
                  marker: {
                    visible: false
                  },
                  'line-color': '#e0564c'
                }
              ]
            }
          ] // close graphset
        } // close data
      })

      renderChart({
        // if you want to change this id , remember to change the selector name in <style> of App.vue
        // there is an !important style to hide the About Zingchart option in App.vue
        id: 'bankCurrent',
        data: {
          gui: {
            contextMenu: {
              button: {
                visible: true
              },
              'custom-items': [
                {
                  id: 'reloadCurrent',
                  function: 'reloadCurrent()',
                  text: 'Reload'
                }
              ],
              position: 'right'
            },
            behaviors: md.mobile() !== null ? MOBILE_BEHAVIOR_CONFIG : BEHAVIOR_CONFIG
          },
          graphset: [
            {
              title: {
                text: 'Current (Outputs)',
                bold: false,
                fontSize: md.mobile() !== null ? '14px' : '18px'
              },
              type: 'line',
              x: 0,
              y: 0,
              width: '100%',
              height: 250,
              plotarea: {
                margin: '50 25 20 50'
              },
              'scale-x': {
                step: 1000,
                transform: {
                  type: 'date',
                  text: '%H:%i:%s',
                  item: {
                    visible: false
                  }
                }
              },
              'scale-y': {
                values: this.isEurope ? '16:0:4' : '15:0:3',
                format: '%v A',
                tick: {
                  'line-color': '#29A2CC'
                },
                item: {
                  'font-color': '#29A2CC'
                }
              },
              refresh: {
                type: 'feed',
                resetTimeout: 1000,
                transport: 'js',
                url: 'bankCurrentCallback()',
                maxTicks: 30,
                interval: 1000
              },
              series: vue.curSeries
            }
          ]
        }
      })
      renderChart({
        // if you want to change this id , remember to change the selector name in <style> of App.vue
        // there is an !important style to hide the About Zingchart option
        id: 'bankPower',
        data: {
          gui: {
            contextMenu: {
              button: {
                visible: true
              },
              'custom-items': [
                {
                  id: 'reloadPower',
                  function: 'reloadPower()',
                  text: 'Reload'
                }
              ],
              position: 'right'
            },
            behaviors: md.mobile() !== null ? MOBILE_BEHAVIOR_CONFIG : BEHAVIOR_CONFIG
          },
          graphset: [
            {
              title: {
                text: 'Power (Outputs)',
                bold: false,
                fontSize: md.mobile() !== null ? '14px' : '18px'
              },
              type: 'line',
              x: 0,
              y: 0,
              width: '100%',
              height: 250,
              plotarea: {
                margin: '50 25 20 50'
              },
              'scale-x': {
                step: 1000,
                transform: {
                  type: 'date',
                  text: '%H:%i:%s',
                  item: {
                    visible: false
                  }
                }
              },
              'scale-y': {
                values: this.isEurope ? '0:3600:600' : '0:2100:300',
                format: '%v W',
                tick: {
                  'line-color': '#29A2CC'
                },
                item: {
                  'font-color': '#29A2CC'
                }
              },
              refresh: {
                type: 'feed',
                resetTimeout: 1000,
                transport: 'js',
                url: 'bankPowerCallback()',
                maxTicks: 30,
                interval: 1000
              },
              series: vue.powerSeries
            }
          ]
        }
      })
    })
    .catch(err => {
      // console.log(err)
      this.alert('danger', 'No response', err)
    })
  },
  data () {
    return {
      testData: {},
      filter: ['1', '2', '3'],
      typeOption: '',
      isEurope: false,
      banks: {},
      input: {},
      curSeries: [],
      powerSeries: [],
      timezone: {},
      currentTime: '',
      colors: [
        '#1f77b4',
        '#ff7f0e',
        '#357935'
      ]
    }
  },
  methods: {
    alert (type, title, content) {
      this.$dispatch('alert', {
        type: type,
        title: title,
        content: content
      })
    },
    chkAmount () {
      setTimeout(() => {
        if (this.filter.length > 3) {
          this.filter.shift()
        }
      }, 100)
    },
    updateTime () {
      this.currentTime = Date.now()
      let vue = this
      setTimeout(function () {
        vue.updateTime()
      }, 1000)
    }
  },
  computed: {
    deviceTime () {
      if (this.timezone.useDaylight && moment().isDST()) {
        return moment(this.currentTime).utc().add(this.timezone.offset, 'seconds').add(this.timezone.dstSavings, 'seconds').format(DEVICE_TIME_FORMAT)
      } else {
        return moment(this.currentTime).utc().add(this.timezone.offset, 'seconds').format(DEVICE_TIME_FORMAT)
      }
    },
    filteredCurrent () {
      let obj = {}
      let offset = moment.parseZone(moment(this.currentTime).utcOffset())
      for (let key of this.filter) {
        if (this.testData.banks[key].current >= 0) {
          let toAdd = {}
          toAdd['plot' + this.filter.indexOf(key)] = this.testData.banks[key].current
          if (this.timezone.useDaylight) {
            toAdd['scale-x'] = moment(this.currentTime - offset * 60000 + this.timezone.dstSavings * 1000).add(this.timezone.offset, 'seconds').valueOf()
          } else {
            // Because zingChart did the locale transform for use, so just revise the current time to UTC time and pass it into ZingChart so the value of scale-x would be correct.
            toAdd['scale-x'] = moment(this.currentTime - offset * 60000).add(this.timezone.offset, 'seconds').valueOf()
          }
          _.merge(obj, toAdd)
        }
      }
      return obj
    },
    filteredPower () {
      let obj = {}
      let offset = moment.parseZone(moment(this.currentTime).utcOffset())
      for (let i of Object.keys(this.testData.banks)) {
        if (this.filter.indexOf(i) !== -1 && this.testData.banks[i].power >= 0) {
          let toAdd = {}
          toAdd['plot' + this.filter.indexOf(i)] = this.testData.banks[i].power
          if (this.timezone.useDaylight) {
            toAdd['scale-x'] = moment(this.currentTime - offset * 60000 + this.timezone.dstSavings * 1000).add(this.timezone.offset, 'seconds').valueOf()
          } else {
            toAdd['scale-x'] = moment(this.currentTime - offset * 60000).add(this.timezone.offset, 'seconds').valueOf()
          }
          _.merge(obj, toAdd)
        }
      }
      return obj
    }
  },
  watch: {
    filter (nV) {
      this.curSeries = []
      this.powerSeries = []
      for (let [idx, key] of nV.entries()) {
        let obj = {
          text: `Bank${key}`,
          values: [],
          marker: {
            visible: false
          },
          scales: 'scale-x,scale-y',
          'line-color': this.colors[idx]
        }
        this.curSeries.push(obj)
        this.powerSeries.push(obj)
      }
      exec('bankCurrent', 'clearfeed')
      exec('bankPower', 'clearfeed')
      exec('inputVoltage', 'clearfeed')
    }
  },
  ready () {
    console.log('ready')
    this.updateTime()
    let offset = moment.parseZone(moment(this.currentTime).utcOffset())  // minutes
    window.inputVoltageCallback = (cb) => {
      cb(JSON.stringify({
        plot0: this.testData.input.voltage,
        'scale-x': this.timezone.useDaylight ? moment(this.currentTime - offset * 60000 + this.timezone.dstSavings * 1000).add(this.timezone.offset, 'seconds').valueOf() : moment(this.currentTime - offset * 60000).add(this.timezone.offset, 'seconds').valueOf()
      }))
    }
    window.bankCurrentCallback = (cb) => {
      cb(JSON.stringify(this.filteredCurrent))
    }
    window.bankPowerCallback = (cb) => {
      cb(JSON.stringify(this.filteredPower))
    }
    window.reloadInput = () => {
      exec('inputVoltage', 'clearfeed')
    }
    window.reloadCurrent = () => {
      exec('bankCurrent', 'clearfeed')
    }
    window.reloadPower = () => {
      exec('bankPower', 'clearfeed')
    }
  },
  beforeDestroy () {
    console.log('b4 destroy')
    exec('inputVoltage', 'destroy')
    exec('bankCurrent', 'destroy')
    exec('bankPower', 'destroy')
  },
  events: {
    status (mac, {banks, input}) {
      // console.log(banks)
      // console.log(input)
      this.isEurope = input.voltage > 200
      this.testData = { banks, input }
    },
    update (mac, {type, event, msg}) {
      if (type === 'timezone') {
        this.timezone = event.timezone
        exec('inputVoltage', 'clearfeed')
        exec('bankCurrent', 'clearfeed')
        exec('bankPower', 'clearfeed')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
  @import '~__vendor_variables_scss__';
  @import '~sass/_breakpoint.scss';

  .char{
    height: 300px;
  }
  .input_voltage{
    border-bottom: 1px solid $pri_gray;
  }
  #inputVoltage{
    height: 300px;
  }
  .char{
    @include breakpoint(xxs){
      height: 250px;
    }
    @include breakpoint(sm) {
      height: 300px;
    }
  }
  .filter_group{
    padding-top: $space_xxs;
    font-size: 26px;
    @include breakpoint(xxs){
      font-size: 14px;
    }
    & .filter__single{
      float: left;
      padding: 5px 7px;
      color: $GLOBAL_comment_fg;
      // @each $i in $bank_colors {
      //   &:nth-child(#{nth($i, 1)}) {
      //     & input:checked + label{
      //       color:#{nth($i, 2)};
      //    }
      //   }
      // }
      @include breakpoint(xxs){
        width: 33%;
        padding-left: 0;
        padding-right: 0;
      }
    }
    & .filter__single.blue{
      color: $bank_color1
    }
    & .filter__single.orange{
      color: $bank_color2
    }
    & .filter__single.green{
      color: $bank_color3
    }
  }
  .typeOption {
    font-size: 26px;
    line-height: 30px;
    @include breakpoint(sm) {
      font-size: 22px;
    }
    @include breakpoint(xxs) {
      font-size: 18px;
    }
  }
  .fa_checkbox label::before{
    margin-right: 20px;
  }

  .reminding {
    font-size: 10px;
    color: #f44;
  }

</style>



// WEBPACK FOOTER //
// Analysis.vue?0909cca9